import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";
import { cn } from "@/utils/common/styleHelper/utils";

const SkeletonHotelSearchBoxComponent: FC = () => {
  const dynamicWidthHeight = [
    { width: "md:w-[563px]", height: "" },
    { width: "md:w-[383.33px]", height: "xl:h-[66px]" },
    { width: "md:w-[178.67px]", height: "" },
  ];

  return (
    <div className="flex flex-col gap-4 rounded-2xl bg-white p-4 shadow-search-mobile md:p-6 md:shadow-search">
      <Skeleton className="h-16 w-full" />
      <div className="flex w-full flex-col gap-4 md:flex-row">
        {dynamicWidthHeight.map(({ width, height }, index) => (
          <Skeleton
            key={index}
            className={cn(
              "h-16 w-full",
              width,
              height,
              index === dynamicWidthHeight.length - 1 ? "h-12 md:h-16" : "",
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default SkeletonHotelSearchBoxComponent;
